export default __webpack_public_path__ + "static/media/certilyticsa-3.4fb884cd.svg";